'use strict';

const VK_TAB         = 9;
const VK_ENTER       = 13;
const VK_ESC         = 27;
const VK_SPACE       = 32;
const VK_PAGE_UP     = 33;
const VK_PAGE_DOWN   = 34;
const VK_END         = 35;
const VK_HOME        = 36;
const VK_ARROW_LEFT  = 37;
const VK_ARROW_UP    = 38;
const VK_ARROW_RIGHT = 39;
const VK_ARROW_DOWN  = 40;

const ARIA_EXPANDED        = 'aria-expanded';
const ARIA_HIDDEN          = 'aria-hidden';
const ARIA_MULTISELECTABLE = 'aria-multiselectable';
const ARIA_SELECTED        = 'aria-selected';

const IS_DIRTY      = 'is-dirty';
const IS_DISABLED   = 'is-disabled';
const IS_EXPANDED   = 'is-expanded';
const IS_FOCUSED    = 'is-focused';
const IS_INVALID    = 'is-invalid';
const IS_UPGRADED   = 'is-upgraded';
const DATA_UPGRADED = 'data-upgraded';

const MDL_RIPPLE                      = 'mdl-ripple';
const MDL_RIPPLE_COMPONENT            = 'MaterialRipple';
const MDL_RIPPLE_EFFECT               = 'mdl-js-ripple-effect';
const MDL_RIPPLE_EFFECT_IGNORE_EVENTS = 'mdl-js-ripple-effect--ignore-events';

export {
  VK_TAB,
  VK_ENTER,
  VK_ESC,
  VK_SPACE,
  VK_PAGE_UP,
  VK_PAGE_DOWN ,
  VK_END,
  VK_HOME,
  VK_ARROW_LEFT,
  VK_ARROW_UP,
  VK_ARROW_RIGHT,
  VK_ARROW_DOWN ,
  ARIA_EXPANDED,
  ARIA_HIDDEN,
  ARIA_MULTISELECTABLE,
  ARIA_SELECTED,
  IS_DIRTY,
  IS_DISABLED,
  IS_EXPANDED,
  IS_FOCUSED,
  IS_INVALID,
  IS_UPGRADED,
  DATA_UPGRADED ,
  MDL_RIPPLE,
  MDL_RIPPLE_COMPONENT,
  MDL_RIPPLE_EFFECT,
  MDL_RIPPLE_EFFECT_IGNORE_EVENTS
};



// WEBPACK FOOTER //
// ./src/utils/constants.js